// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"601":"bfee79f4","2583":"2fef0385","2605":"bfee79f4","7877":"bfee79f4"}[chunkId] + ".chunk.css";
};